import { LoginpageComponent } from './components/login-page/login-page.component';
import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { AuthRoutingModule } from './auth-routing.module';
import { ResetMailComponent } from './components/reset-mail/reset-mail.component';
import { ResetPasswordComponent } from './components/reset-password/reset-password.component';
import { CodeResetComponent } from './components/code-reset/code-reset.component';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { RegisterComponent } from './components/register/register.component';
import { NgSelectModule } from '@ng-select/ng-select';
import { FieldErrorModule } from './../shared/components/shared-field-error/field-error.module';
import { CodeVerificationComponent } from './components/code-verification/code-verification.component';
import { RouterModule } from '@angular/router';
import { LoginintervenantComponent } from './components/login-intervenant/loginintervenant/loginintervenant.component';
import { NgxSpinnerModule } from 'ngx-spinner';
import { InitPasswordComponent } from './components/init-password/init-password.component';
import { SharedModule } from 'app/shared/shared.module';
@NgModule({
  declarations: [
    LoginpageComponent,
    ResetMailComponent,
    ResetPasswordComponent,
    CodeResetComponent,
    RegisterComponent,
    CodeVerificationComponent,
    LoginintervenantComponent,
    InitPasswordComponent
  ],
  imports: [
    CommonModule,
    AuthRoutingModule,
    FormsModule,
    ReactiveFormsModule,
    NgSelectModule,
    FieldErrorModule,
    RouterModule,
    NgxSpinnerModule,
    SharedModule
  ],
})
export class AuthModule {}
